import { BrandName } from '../../../windows-types';

export const CERTIFICATE_BLOCK_MAP: Record<BrandName, Record<string, string>> = {
  deceuninck: {
    href:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/windows/Deceuninck_partner_certificate_LemanaPro.pdf',
    title: 'Сертификат DECEUNINCK',
  },
  rehau: {
    href:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/windows/Rehau_partner_certificate_LemanaPro.pdf',
    title: 'Сертификат REHAU',
  },
  veka: {
    href:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/windows/Veka_partner_certificate_LemanaPro.pdf',
    title: 'Сертификат VEKA',
  },
};
